import {
  BannerOutdoorDesktop,
  BannerOutdoorMobile,
  BannerOutdoorTablet,
  BannerRtlsDesktop,
  BannerRtlsMobile,
  BannerRtlsTablet,
  BannerVideoDesktop,
  BannerVideoMobile,
  BannerVideoTablet,
  HomeAccess1D,
  HomeAccess1M,
  HomeAccess1T,
  HomeAccess2D,
  HomeAccess2M,
  HomeAccess2T,
  HomeAccess3D,
  HomeAccess3M,
  HomeAccess3T,
  HomeAccess4D,
  HomeAccess4M,
  HomeAccess4T,
  HomeAccess5D,
  HomeAccess5M,
  HomeAccess5T,
  HomeBeacon1D,
  HomeBeacon1M,
  HomeBeacon1T,
  HomeBeacon2D,
  HomeBeacon2M,
  HomeBeacon2T,
  HomeBeacon3D,
  HomeBeacon3M,
  HomeBeacon3T,
  HomeBeacon4D,
  HomeBeacon4M,
  HomeBeacon4T,
  HomeBeacon5D,
  HomeBeacon5M,
  HomeBeacon5T,
  HomeBeacon6D,
  HomeBeacon6M,
  HomeBeacon6T,
  HomeProductAoaDesktop,
  HomeProductAoaMobile,
  HomeProductAoaTablet,
  HomeProductBleDesktop,
  HomeProductBleMobile,
  HomeProductBleTablet,
  HomeProductComfortDesktop,
  HomeProductComfortMobile,
  HomeProductComfortTablet,
  HomeProductEdgeDesktop,
  HomeProductEdgeMobile,
  HomeProductEdgeTablet,
  HomeProductServerDesktop,
  HomeProductServerMobile,
  HomeProductServerTablet,
  HomeProductUwbDesktop,
  HomeProductUwbMobile,
  HomeProductUwbTablet,
  HomeRTLS1D,
  HomeRTLS1M,
  HomeRTLS1T,
  HomeRTLS2D,
  HomeRTLS2M,
  HomeRTLS2T,
  HomeRTLS3D,
  HomeRTLS3M,
  HomeRTLS3T,
  HomeSolution1D,
  HomeSolution1M,
  HomeSolution1T,
  HomeSolution2D,
  HomeSolution2M,
  HomeSolution2T,
  HomeSolution3D,
  HomeSolution3M,
  HomeSolution3T,
  HomeSolution4D,
  HomeSolution4M,
  HomeSolution4T,
  HomeSolutionLandConstruction,
  HomeSolutionLandLogistics,
  HomeSolutionLandManufacture,
  HomeSolutionLandMedical,
  HomeSolutionLandOffice,
  HomeSolutionLandRetail,
  HomeSolutionPortConstruction,
  HomeSolutionPortLogistics,
  HomeSolutionPortManufacture,
  HomeSolutionPortMedical,
  HomeSolutionPortOffice,
  HomeSolutionPortRetail,
} from '@assets/images/main/home';
import { HomeDTBanner } from '@assets/images/main/home/dt';

export default {
  titleBanner: {
    title: 'Nền tảng chuyên về theo dõi vị trí và Digital Twin',
    description: 'Đổi mới không gian với định vị thời gian thực, hệ thống kiểm soát ra vào, Digital Twin và IIoT',
  },

  productText: {
    title: 'Sản phẩm Digital Twin và Theo dõi vị trí',
    description: 'Mang đến sự mới mẻ mà ORBRO đề xuất cho bạn đang tìm kiếm thay đổi',
  },

  banner: {
    productCard: [
      {
        title: 'Định vị trong nhà',
        desc: 'Theo dõi vị trí dựa trên công nghệ truyền thông không dây như BLE, AoA, UWB',
        link: '/vi/rtls',
        bgImg: {
          desktop: BannerRtlsDesktop,
          tablet: BannerRtlsTablet,
          mobile: BannerRtlsMobile,
        },
      },
      {
        title: 'Định vị qua video',
        desc: 'Theo dõi đối tượng bằng công nghệ video dựa trên AI',
        link: '/vi/camera',
        bgImg: {
          desktop: BannerVideoDesktop,
          tablet: BannerVideoTablet,
          mobile: BannerVideoMobile,
        },
      },
      {
        title: 'Định vị ngoài trời',
        desc: 'Theo dõi vị trí phương tiện xe cộ và khu vực ngoài trời',
        link: '/vi/outdoor',
        bgImg: {
          desktop: BannerOutdoorDesktop,
          tablet: BannerOutdoorTablet,
          mobile: BannerOutdoorMobile,
        },
      },
    ],
  },

  os: {
    title: 'Nền tảng Digital Twin dựa trên định vị vị trí',
    desc: 'ORBRO OS tái hiện không gian thực tế trên màn hình ảo. Thu thập dữ liệu nhanh chóng và chính xác theo thời gian thực, mang lại sự tiện lợi vượt trội cho người dùng.',
  },

  rtls: {
    title: 'Dòng sản phẩm theo dõi vị trí ứng dụng cho mọi hiện trường',
    desc: 'Cung cấp dòng sản phẩm theo dõi bằng sóng (BLE, UWB) và theo dõi bằng video + AI.',

    card: [
      {
        tag: 'Theo dõi vị trí thời gian thực',
        title: 'Thực tại trong không gian ảo',
        link: 'https://orbro.io/vi/rtls',
        img: {
          desktop: HomeRTLS1D,
          tablet: HomeRTLS1T,
          mobile: HomeRTLS1M,
        },
      },
      {
        title: 'Theo dõi với Beacon',
        desc: 'Hệ thống theo dõi vị trí qua BLE Beacon',
        link: 'https://orbro.io/vi/beacon/ble',
        img: {
          desktop: HomeRTLS2D,
          tablet: HomeRTLS2T,
          mobile: HomeRTLS2M,
        },
      },
      {
        title: 'Theo dõi bằng Camera AI',
        desc: 'Theo dõi vị trí & phát hiện hành vi bất thường bằng AI',
        link: 'https://orbro.io/vi/camera',
        img: {
          desktop: HomeRTLS3D,
          tablet: HomeRTLS3T,
          mobile: HomeRTLS3M,
        },
      },
    ],
  },

  access: {
    title: 'Kiểm soát ra vào không tiếp xúc tự nhiên qua di động',
    desc: 'Cung cấp cách ra vào thế hệ mới bằng di động và nhận diện khuôn mặt.',

    card: [
      {
        tag: 'Cung cấp đa phương thức ra vào',
        title: 'NFC/Bluetooth/Smartphone<br/>Mọi hình thức ra vào',
        sub: 'Hỗ trợ thẻ NFC, ra vào bằng di động, đồng hồ thông minh.',
        img: {
          desktop: HomeAccess1D,
          tablet: HomeAccess1T,
          mobile: HomeAccess1M,
        },
      },
      {
        title: 'Access Pro',
        link: 'https://orbro.io/vi/access/pro',
        desc: 'Hỗ trợ mọi phương thức ra vào: khuôn mặt, thẻ NFC, di động',
        img: {
          desktop: HomeAccess2D,
          tablet: HomeAccess2T,
          mobile: HomeAccess2M,
        },
      },
      {
        title: 'Access Auto',
        link: 'https://orbro.io/vi/access/auto',
        desc: 'Tối ưu hóa ra vào bằng di động',
        img: {
          desktop: HomeAccess3D,
          tablet: HomeAccess3T,
          mobile: HomeAccess3M,
        },
      },
      {
        title: 'Phụ kiện',
        desc: 'Cung cấp đa dạng phụ kiện kiểm soát ra vào',
        link: 'https://orbro.io/vi/access/accessory',
        img: {
          desktop: HomeAccess4D,
          tablet: HomeAccess4T,
          mobile: HomeAccess4M,
        },
      },
      {
        title: 'Access Lite',
        desc: 'Hệ thống ra vào di động cơ bản, hỗ trợ NFC và Apple Watch',
        tag: 'Sắp ra mắt',
        img: {
          desktop: HomeAccess5D,
          tablet: HomeAccess5T,
          mobile: HomeAccess5M,
        },
      },
    ],
  },

  dt: {
    title: 'Đầu tiên trên thế giới về chuyển đổi số thế hệ thứ 3<br/>Nền tảng Digital Twin chuyên nghiệp',
    desc: 'Trải nghiệm đột phá với giải pháp Digital Twin của ORBRO, mô phỏng thành phố trên không gian ảo.',
    img: HomeDTBanner,
  },

  beacon: {
    title: 'IIoT & Hệ thống Beacon công nghiệp',
    desc: 'Tạo môi trường làm việc hiệu quả với đa dạng cảm biến và hệ thống Beacon công nghiệp.',

    card: [
      {
        title: 'ALESS-GW',
        desc: 'Bộ trung gian LoRA',
        link: 'https://orbro.io/vi/iot/LoRAGateway',
        img: {
          desktop: HomeBeacon1D,
          tablet: HomeBeacon1T,
          mobile: HomeBeacon1M,
        },
      },
      {
        title: 'ALESS-BA',
        desc: 'Cảm biến công nghiệp dùng LoRA',
        link: 'https://orbro.io/vi/iot/LoRASensor',
        img: {
          desktop: HomeBeacon2D,
          tablet: HomeBeacon2T,
          mobile: HomeBeacon2M,
        },
      },
      {
        title: 'VENTAX CO+',
        desc: 'Máy đo carbon monoxide',
        link: 'https://orbro.io/vi/iot/co2',
        img: {
          desktop: HomeBeacon3D,
          tablet: HomeBeacon3T,
          mobile: HomeBeacon3M,
        },
      },
      {
        title: 'VENTAX',
        desc: 'Máy đo chất lượng không khí',
        link: 'https://orbro.io/vi/iot/air',
        img: {
          desktop: HomeBeacon4D,
          tablet: HomeBeacon4T,
          mobile: HomeBeacon4M,
        },
      },
      {
        title: 'Plutocon Pro',
        desc: 'Thiết bị beacon công nghiệp',
        link: 'https://orbro.io/vi/beacon/industry',
        img: {
          desktop: HomeBeacon5D,
          tablet: HomeBeacon5T,
          mobile: HomeBeacon5M,
        },
      },
      {
        title: 'ORBRO Tag',
        desc: 'Thiết bị beacon nhỏ gọn',
        link: 'https://orbro.io/vi/beacon/tag',
        img: {
          desktop: HomeBeacon6D,
          tablet: HomeBeacon6T,
          mobile: HomeBeacon6M,
        },
      },
    ],
  },

  products: {
    title: 'Giải pháp sóng vô tuyến ORBRO, định vị không dây chính xác cao',
    desc: 'Đảm bảo dữ liệu vị trí theo thời gian thực với công nghệ BLE, UWB, AoA',
    button: 'Liên hệ tư vấn',
    buttonLink: 'https://orbro.io/vi/request',
    card: [
      {
        title: 'TwinTracker BLE',
        desc: 'Theo dõi tài sản, con người và phương tiện xe cộ trong nhà, ngoài trời một cách kinh tế, dựa trên tín hiệu BLE tiết kiệm năng lượng.',
        link: '/vi/rtls/ble',
        img: {
          desktop: HomeProductBleDesktop,
          tablet: HomeProductBleTablet,
          mobile: HomeProductBleMobile,
        },
      },
      {
        title: 'TwinTracker AoA',
        desc: 'Tính toán Góc tới (Angle of Arrival) của tín hiệu BLE để cung cấp thông tin vị trí với độ chính xác cao.',
        link: '/vi/rtls/aoa',
        img: {
          desktop: HomeProductAoaDesktop,
          tablet: HomeProductAoaTablet,
          mobile: HomeProductAoaMobile,
        },
      },
      {
        title: 'TwinTracker UWB',
        desc: 'Hỗ trợ theo dõi vị trí thời gian thực với độ chính xác cao bằng công nghệ băng thông siêu rộng UWB.',
        link: '/vi/rtls/uwb',
        img: {
          desktop: HomeProductUwbDesktop,
          tablet: HomeProductUwbTablet,
          mobile: HomeProductUwbMobile,
        },
      },
      {
        title: 'Comfort Kit',
        desc: 'Hệ thống theo dõi vị trí BLE độc lập, dễ dàng sử dụng qua ứng dụng di động mà không cần cài đặt Server máy chủ.',
        link: '/vi/rtls/comfort',
        img: {
          desktop: HomeProductComfortDesktop,
          tablet: HomeProductComfortTablet,
          mobile: HomeProductComfortMobile,
        },
      },
    ],
  },

  camera: {
    title: 'Theo dõi vị trí dựa trên video',
    desc: 'Sử dụng công nghệ phân tích video AI để theo dõi vị trí của người, phương tiện giao thông và đối tượng theo thời gian thực.',
    card: [
      {
        title: 'ORBRO Edge AI',
        desc: 'Thiết bị Edge dành cho cài đặt quy mô nhỏ (hỗ trợ tối đa 2 camera)',
        link: '/vi/camera/edge',
        img: {
          desktop: HomeProductEdgeDesktop,
          tablet: HomeProductEdgeTablet,
          mobile: HomeProductEdgeMobile,
        },
      },
      {
        title: 'ORBRO AI Server',
        desc: 'Hỗ trợ kết nối đồng thời nhiều camera trên quy mô lớn (phiên bản Enterprise)',
        link: '/vi/camera/server',
        img: {
          desktop: HomeProductServerDesktop,
          tablet: HomeProductServerTablet,
          mobile: HomeProductServerMobile,
        },
      },
    ],
  },

  solution: {
    title: 'Giải pháp ORBRO kết nối không gian và dữ liệu',
    desc: 'Từ theo dõi vị trí thời gian thực đến phân tích video AI, ORBRO hỗ trợ đổi mới kinh doanh cho khách hàng bằng các công nghệ đa dạng.',
    request: 'Tư vấn giải pháp',
    card: [
      {
        img: '',
        title: 'Xây dựng',
        desc: 'Quản lý thời công nhân, vật liệu, thiết bị nặng theo thời gian thực để nâng cao an toàn và hiệu quả.',
        link: '/vi/enterprise/construction/safety',
        bgImg: {
          desktop: HomeSolutionPortConstruction,
          tablet: HomeSolutionLandConstruction,
          mobile: HomeSolutionLandConstruction,
        },
      },
      {
        img: '',
        title: 'hậu cần',
        desc: 'Theo dõi kho hàng hóa thời gian thực, đồng thời quản lý an toàn công nhân một cách hệ thống.',
        link: '/vi/enterprise/logistics/asset',
        bgImg: {
          desktop: HomeSolutionPortLogistics,
          tablet: HomeSolutionLandLogistics,
          mobile: HomeSolutionLandLogistics,
        },
      },
      {
        img: '',
        title: 'Sản xuất',
        desc: 'Giám sát quy trình và tồn kho thời gian thực, nâng cao năng suất và chất lượng tại nhà máy.',
        link: '/vi/enterprise/manufacturing/process',
        bgImg: {
          desktop: HomeSolutionPortManufacture,
          tablet: HomeSolutionLandManufacture,
          mobile: HomeSolutionLandManufacture,
        },
      },
      {
        img: '',
        title: 'Bệnh viện',
        desc: 'Theo dõi chính xác bệnh nhân và tài sản y tế, đồng thời hỗ trợ tích hợp quản lý chất thải y tế.',
        link: '/vi/enterprise/medical/patient',
        bgImg: {
          desktop: HomeSolutionPortMedical,
          tablet: HomeSolutionLandMedical,
          mobile: HomeSolutionLandMedical,
        },
      },
      {
        img: '',
        title: 'Văn phòng',
        desc: 'Quản lý tài sản trong văn phòng hiệu quả, tăng cường tính hệ thống và an toàn cho môi trường làm việc.',
        link: '/vi/enterprise/office/asset',
        bgImg: {
          desktop: HomeSolutionPortOffice,
          tablet: HomeSolutionLandOffice,
          mobile: HomeSolutionLandOffice,
        },
      },
      {
        img: '',
        title: 'Bán lẻ',
        desc: 'Phân tích dữ liệu khách truy cập nhằm tối ưu hóa hiệu quả vận hành không gian bán lẻ và trải nghiệm khách hàng.',
        link: '/vi/enterprise/retail/exhibition',
        bgImg: {
          desktop: HomeSolutionPortRetail,
          tablet: HomeSolutionLandRetail,
          mobile: HomeSolutionLandRetail,
        },
      },
    ],
  },

  faq: {
    title: 'Câu hỏi thường gặp',
    list: [
      {
        q: 'Giải pháp theo dõi vị trí ORBRO có thể sử dụng cả trong nhà và ngoài trời không?',
        a: 'Vâng, có thể sử dụng cho cả trong nhà và ngoài trời. Hệ thống sản phẩm chúng tôi có thể đáp ứng được đa dạng các loại môi trường, sử dụng các công nghệ truyền thông không dây (BLE, UWB, AoA), phân tích video AI, và GPS (cho phương tiện xe cộ và khu vực ngoài trời).',
      },
      {
        q: 'Sự khác biệt giữa theo dõi vị trí dựa trên sóng vô tuyến và theo dõi vị trí dựa trên video là gì?',
        a: 'Theo dõi vị trí dựa trên sóng vô tuyến sử dụng các tín hiệu không dây như BLE, UWB, AoA để tính toán vị trí với độ chính xác cao. Theo dõi vị trí dựa trên video sẽ phân tích hình ảnh từ camera bằng AI để theo dõi vị trí của người, phương tiện, v.v. theo thời gian thực. Tùy theo nhu cầu, có thể áp dụng kết hợp cả hai công nghệ.',
      },
      {
        q: 'Để lắp đặt sản phẩm ORBRO, có cần Server hay thiết bị riêng biệt bổ sung nào không?',
        a: 'Điều này sẽ tùy thuộc vào sản phẩm. Comfort Kit có thể sử dụng chỉ với ứng dụng di động mà không cần Server riêng. TwinTracker BLE, UWB, AoA được sử dụng cùng với ORBRO Server hoặc thiết bị Edge. Theo dõi vị trí dựa trên video (Edge AI, AI Server) thì cần cài đặt camera và liên kết với Server.',
      },
      {
        q: 'Có thể lắp đặt ở không gian quy mô nhỏ được không?',
        a: 'Vâng, có thể. Đối với các không gian quy mô nhỏ như văn phòng, nhà kho, hoặc công trường tạm thời, giải pháp Comfort Kit hoặc ORBRO Edge AI sẽ phù hợp. Chúng tôi sẽ đề xuất giải pháp tối ưu tùy theo quy mô và môi trường của bạn.',
      },
      {
        q: 'Dữ liệu theo dõi vị trí có thể được ứng dụng như thế nào?',
        a: 'Với ORBRO OS, bạn có thể theo dõi vị trí thời gian thực trên bản đồ số. Ngoài ra, API của ORBRO cho phép tích hợp với hệ thống khách hàng, hoặc ứng dụng đa dạng vào việc như quản lý tài sản, giám sát nhân sự, quản lý an toàn, v.v.',
      },
      {
        q: 'Sản phẩm ORBRO có thể được lắp đặt nhanh trong bao lâu?',
        a: 'Comfort Kit có thể sử dụng ngay trong vài giờ. Hệ thống TwinTracker và các hệ thống định vị qua video cần từ vài ngày để lắp đặt, tùy thuộc vào quy mô công trình.',
      },
      {
        q: 'Có thể vận hành chỉ trong mạng nội bộ mà không gửi dữ liệu ra Server bên ngoài không?',
        a: 'Vâng, bạn có thể xây dựng ORBRO Server hoặc AI Server trên mạng nội bộ (Local Network) để vận hành an toàn mà không cần kết nối Internet bên ngoài.',
      },
      {
        q: 'Giải pháp ORBRO có khả năng mở rộng không?',
        a: 'Vâng, ORBRO hỗ trợ mở rộng hệ thống bằng cách bổ sung cảm biến, camera, hoặc tích hợp thêm thiết bị. API của ORBRO cũng cho phép liên kết linh hoạt với các hệ thống bên ngoài.',
      },
      {
        q: 'Khi triển khai giải pháp ORBRO, việc bảo trì sẽ được tiến hành như thế nào?',
        a: 'Sau khi lắp đặt, chúng tôi cung cấp hỗ trợ bảo trì cơ bản. Nếu cần, bạn có thể ký hợp đồng riêng để nhận dịch vụ kiểm tra định kỳ và hỗ trợ kỹ thuật.',
      },
    ],
  },

  product: {
    items: [
      {
        title: 'Theo dõi vị trí không dây',
        description: 'Quản lý tài sản hoàn hảo và vị trí chính xác qua sóng vô tuyến',
        link: '/vi/rtls',
      },
      {
        title: 'Theo dõi vị trí bằng camera',
        description: 'Hệ thống theo dõi vị trí qua AI camera',
        link: '/vi/camera',
      },
      {
        title: 'Hệ thống ra vào',
        description: 'Nhanh hơn, thông minh hơn – hệ thống ra vào mới',
        link: '/vi/access',
      },
      {
        title: 'Cảm biến công nghiệp',
        description: 'Từ phát hiện cháy đến đo nhiệt độ & độ ẩm – sẵn sàng cho hiện trường',
        link: '/vi/iot/LoRAGateway',
      },
      {
        title: 'IoT',
        description: 'Thay đổi bất ngờ từ những điều đơn giản',
        link: '/vi/iot/bell',
      },
      {
        title: 'Thiết bị beacon',
        description: 'Hệ thống Beacon hoàn chỉnh',
        link: '/vi/beacon/industry',
      },
    ],
  },

  control: {
    title: 'Quản lý tích hợp qua ORBRO',
    description: 'Chỉ một phần mềm<br/>Từ di động tới desktop, đơn giản chỉ những gì cần thiết',
  },

  showMore: 'Tìm hiểu thêm',
};
